import { TrackingParamsRepository } from './types';
import { getMktportalParams } from './mktportal';
import { getUtmParameters } from './utm';

export const createTrackingParamsRepository = (): TrackingParamsRepository => {
  return {
    getUtmParams: getUtmParameters,
    getMktportalParams,
  };
};
